import React from "react";
import { Dialog, DialogContent, IconButton, Box } from "@mui/material";
import { Close } from "@mui/icons-material";
import DashboardInfo from "./DashboardInfo"; 

export default function DashboardInfoDialog({ open, onClose, pageName }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "16px", maxHeight: "90vh" },
      }}
    >
      {/* Close button */}
      <Box sx={{ position: "absolute", top: 8, right: 8, zIndex: 10 }}>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </Box>

      <DialogContent sx={{ p: 0, overflow: "auto" }}>
        <DashboardInfo dialogMode pageName={pageName} />
      </DialogContent>
    </Dialog>
  );
}